// src/config/blockThemes.js
const blockThemes = [
  {
    style: {
      "--theme-color": "var(--white)",
      "--theme-high-contrast-color": "var(--lightgrey)",
      "--theme-foreground-color": "var(--charcoal)",
      "--theme-low-contrast-foreground-color": "var(--grey)",
    },
    name: "default",
    label: "Default",
  },
  {
    style: {
      "--theme-color": "var(--lightgrey)",
      "--theme-high-contrast-color": "var(--charcoal)",
      "--theme-foreground-color": "var(--charcoal)",
      "--theme-low-contrast-foreground-color": "var(--grey)",
    },
    name: "lightgrey",
    label: "Light Grey",
  },
  {
    style: {
      "--theme-color": "var(--base)",
      "--theme-high-contrast-color": "var(--white)",
      "--theme-foreground-color": "var(--white)",
      "--theme-low-contrast-foreground-color": "rgba(255,255,255,0.55",
    },
    name: "base",
    label: "Base",
  },
  {
    style: {
      "--theme-color": "var(--accent)",
      "--theme-high-contrast-color": "var(--white)",
      "--theme-foreground-color": "var(--white)",
      "--theme-low-contrast-foreground-color": "rgba(255,255,255,0.55",
    },
    name: "accent",
    label: "Accent",
  },
];

export default blockThemes;
